// Upsell « module cosmétique » — écran affiché si l'utilisatrice ouvre un écran du module
// 'cosmetique' (formulateur, lots cosmétiques…) sans posséder ce module. Pendant visuel du
// verrou serveur (exigeModule → 403). En temps normal l'entrée de menu est masquée ; cet écran
// couvre l'accès direct par URL/état. Deux issues : activer le module (Réglages › Abonnement)
// ou revenir en arrière.
//
// `titre` / `description` sont paramétrables selon l'écran verrouillé ; leurs valeurs par
// défaut décrivent le formulateur (usage historique).

interface Props {
  onSabonner: () => void
  onRetour: () => void
  titre?: string
  description?: string
}

const TITRE_DEFAUT = '⚗️ Formulateur cosmétique'
const DESCRIPTION_DEFAUT =
  "Le formulateur cosmétique fait partie du module « Cosmétique » (formulation d'émulsions, " +
  "sérums, gels et baumes, avec calcul HLB et contrôles réglementaires). Il n'est pas encore " +
  'activé sur ton compte.'

export default function UpsellModuleCosmetique({
  onSabonner,
  onRetour,
  titre = TITRE_DEFAUT,
  description = DESCRIPTION_DEFAUT,
}: Props) {
  return (
    <div className="min-h-screen bg-bdspBg flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-bdspIndigoSoft bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-bdspInk">{titre}</h1>
        <p className="mt-3 text-sm text-stone-600">{description}</p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={onSabonner}
            className="rounded-lg bg-bdspIndigo px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90"
          >
            Activer le module
          </button>
          <button
            type="button"
            onClick={onRetour}
            className="rounded-lg border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-bdspInk transition hover:bg-stone-50"
          >
            Retour
          </button>
        </div>
      </div>
    </div>
  )
}
